import * as storageHelper from "../functions/storageHelper";
import * as myStore from '../store/myStore';
import {SESSIONS} from "../constants/constants";
import config from "../libs/webIMConfig";

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

const ReactNative = {
    isProduction: false,
};
try {
    // eslint-disable-next-line no-undef
    ReactNative.isProduction = !__DEV__;
} catch (e) {
    // Not thing
}

const isUserLogin = (xmppId) => {
    return myStore.getStore().getState().loginReducer.userInfo.xmppId === xmppId;
};

const messagesRemoved = [];
const messageBufferStorage = {};

/**
 *
 * @returns {{setKey?, storageCachingSupported?, deleleKey?, getKey?}|{}}
 */
const getStorage = () => {
    if (isNative) {
        // Native handle return storage here
        return {
            setMessageBufferStorage: config.setMessageBufferStorage,
            getMessageBufferStorage: config.getMessageBufferStorage
        };
    } else {
        return storageHelper;
    }
};

messageBufferStorage.bufferStorageCachingSupported = () => {
  return false; // Disable buffer function due to break messenger system
    // if (isNative) {
    //     // Native update logic check here
    //     return true;
    // } else {
    //     return storageHelper.storageCachingSupported();
    // }
};

messageBufferStorage.updateMessageError = async (messageId) => {
    if (messageBufferStorage.bufferStorageCachingSupported()) {
        const storage = getStorage();
        const messagesObject = await messageBufferStorage.getMessages();
        const message = messagesObject[messageId];
        if (message) {
            messagesObject[messageId] = {...message, error: true};
        }
        // console.log("updateMessageError", messageId, messagesObject);
        if (isNative) {
            storage.setMessageBufferStorage(JSON.stringify(messagesObject));
        } else {
            storage.setKey(SESSIONS.MESSENGER_BUFFER_STORAGE, JSON.stringify(messagesObject));
        }
    }
};

/**
 *
 * @param message
 */
messageBufferStorage.setMessage = async (message) => {
    if (messageBufferStorage.bufferStorageCachingSupported()) {
        // console.log("set message to messageBufferStorage: ", message);
        const storage = getStorage();
        const messagesObject = await messageBufferStorage.getMessages();
        messagesObject[message.id] = message;
        if (isNative) {
            storage.setMessageBufferStorage(JSON.stringify(messagesObject))
        } else {
            storage.setKey(SESSIONS.MESSENGER_BUFFER_STORAGE, JSON.stringify(messagesObject));
        }
    }
};

/**
 * Remove both message by messageId and message which not from login user
 * @param messageId
 */
messageBufferStorage.deleteMessage = async (messageId) => {
    try {
        if (messageBufferStorage.bufferStorageCachingSupported()) {
            const storage = getStorage();
            const messagesObject = await messageBufferStorage.getMessages();
            // delete messagesObject[messageId];
            let newMessageObject = {};
            Object.keys(messagesObject).forEach(mid => {
                if (mid !== messageId && messagesObject[mid] && isUserLogin(messagesObject[mid].from) && !messagesRemoved.includes(mid)) {
                  newMessageObject[mid] = messagesObject[mid];
                } else {
                  messagesRemoved.push(mid);
                }
            });
            if (isNative) {
                return storage.setMessageBufferStorage(JSON.stringify(newMessageObject));
            } else {
                return storage.setKey(SESSIONS.MESSENGER_BUFFER_STORAGE, JSON.stringify(newMessageObject));
            }
        }
    } catch (e) {
        console.log(e);
    }

};

messageBufferStorage.clearAll = () => {
    if (messageBufferStorage.bufferStorageCachingSupported()) {
        const storage = getStorage();
        if (isNative) {
            storage.setMessageBufferStorage(JSON.stringify(''))
        } else {
            storage.deleleKey(SESSIONS.MESSENGER_BUFFER_STORAGE);
        }
    }
};

/**
 *
 * @param messageId
 * @returns {null|*}
 */
messageBufferStorage.getMessageById = async (messageId) => {
    if (messageBufferStorage.bufferStorageCachingSupported()) {
        const msg = await messageBufferStorage.getMessages();
        return msg && msg[messageId];
    }
    return null;
};

/**
 *
 * @returns {{}|any}
 */
messageBufferStorage.getMessages = async () => {
    if (messageBufferStorage.bufferStorageCachingSupported()) {
        const storage = getStorage();
        const messagesString = isNative ? await storage.getMessageBufferStorage() : storage.getKey(SESSIONS.MESSENGER_BUFFER_STORAGE);
        return messagesString ? JSON.parse(messagesString) : {};
    }
    return {};
};

export default messageBufferStorage;
